import {
    Container,
    BackToHomeScreen,
    PolicyContainer,
    Heading,
    Paragraph,
    NavigationLink,
    NavigationLinkContainer,
    NavigationLinkDivider,
    Li,
} from '../styled'
import NavigationArrowLink from '../../../../reusable/buttons/NavigationArrowLink'
import { useHistory } from 'react-router'
import { useTypedSelector } from '../../../../../hooks'

const NorliPolicy = () => {
    const history = useHistory()

    const { companyName, organizationalCode } = useTypedSelector(
        (state) => state.whistleblower
    )

    const { lineOfContacts } = useTypedSelector((state) => state.lineOfContact)

    return (
        <>
            <BackToHomeScreen>
                <NavigationArrowLink
                    onClickCallback={() => {
                        history.push(
                            `/organization/${organizationalCode}/whistleblower`
                        )
                    }}
                    linkText={'Tilbake til hjemmesiden'}
                />
            </BackToHomeScreen>
            <Container>
                <NavigationLinkContainer>
                    <NavigationLink active={true}>{companyName}</NavigationLink>
                    <NavigationLinkDivider />
                    <NavigationLink active={false}>
                        Varslingsrutiner
                    </NavigationLink>
                </NavigationLinkContainer>
                <PolicyContainer>
                    <Heading>Norli Varslingsrutiner</Heading>
                    <Paragraph>
                        Vi i Norli er fast bestemt på å drive virksomheten vår i
                        henhold til alle gjeldende lover og anerkjente etiske
                        normer. Vi legger vekt på å opptre åpent og ærlig med
                        høy integritet overfor alle vi har med å gjøre, inkludert
                        våre ansatte, kundene våre, våre forretningsforbindelser
                        og samfunnet generelt. På tross av dette anerkjenner vi
                        at det kan oppstå situasjoner eller være forhold rundt
                        vår virksomhet som kan være kritikkverdige. Disse
                        Varslingsrutinene gir en praktisk beskrivelse av hvordan
                        vi behandler varslinger. De er dessuten en oppfordring
                        til å varsle om faktiske brudd eller alvorlig mistanke om
                        brudd på gjeldende lovgivning, de Etiske Retningslinjene
                        våre eller på etiske normer som det er generell
                        tilslutning til i samfunnet.
                    </Paragraph>

                    <Heading>Hvorfor og Hvordan varsle?</Heading>
                    <Paragraph>
                        Hvis du er i tvil om du skal formidle en varsling om noe
                        du vet eller har mistanke om er et kritikkverdig forhold,
                        oppfordres du til å gjøre det. Varsler gir oss viktig
                        informasjon om forhold som vi må korrigere umiddelbart,
                        eller innsikt som vi tar med oss videre i arbeidet med å
                        utvikle organisasjonen og kulturen vår.
                    </Paragraph>
                    <Paragraph>
                        Klager eller bekymringer kan rapporteres gjennom Norlis
                        varslingskanaler, ref. de Etiske Retningslinjene våre,
                        pkt. 2. Enhver som varsler i god tro, er beskyttet mot
                        alle former for represalier. Dette betyr at ingen som i
                        god tro sender oss varslinger med klager eller
                        bekymringer, vil bli sanksjonert selv om det omvarslede
                        forholdet viser seg ikke å være kritikkverdig.
                    </Paragraph>
                    <Paragraph>
                        Varslinger kan formidles skriftlig eller muntlig, åpent
                        eller anonymt. Alle varslinger behandles strengt
                        konfidensielt og i henhold til gjeldende lovgivning.
                    </Paragraph>
                    <Paragraph>
                        Eventuelle spørsmål vedrørende Norlis Varslingsrutiner
                        eller varslingskanaler kan sendes på e-post til vår
                        eksterne leverandør av varslingstjenester på
                        norli@speakups.org
                    </Paragraph>

                    <Heading>Hvem kan varsle?</Heading>
                    <Paragraph>
                        Varslingsrutinene våre gjelder for personer eller
                        virksomheter som ønsker å rapportere om kritikkverdige
                        forhold de har fått informasjon om gjennom sitt
                        ansettelses-, kunde-, eller forretningsforhold med Norli,
                        inkludert:
                    </Paragraph>
                    <Paragraph>
                        <ul>
                            <Li>
                                Nåværende ansatte inkludert ledere på alle nivåer
                            </Li>
                            <Li>Tidligere ansatte</Li>
                            <Li>Innleide arbeidstakere</Li>
                            <Li>
                                Konsulenter/engasjerte selvstendig
                                næringsdrivende
                            </Li>
                            <Li>Jobbsøkere</Li>
                            <Li>Kunder</Li>
                            <Li>
                                Ansatte hos Norlis forretningsforbindelser
                                inkludert leverandører og underleverandører
                            </Li>
                            <Li>Aksjonærer</Li>
                            <Li>Styremedlemmer</Li>
                            <Li>Betalte eller ubetalte trainee'er</Li>
                            <Li>Frivillige</Li>
                        </ul>
                    </Paragraph>

                    <Heading>
                        Hva kan det varsles om – og hva skal det ikke varsles om?
                    </Heading>
                    <Paragraph>
                        Det kan varsles om faktiske brudd eller alvorlig mistanke
                        om brudd på gjeldende lovgivning, kollektivavtaler,
                        Norlis Etiske Retningslinjer eller etiske normer som det
                        er generell tilslutning til i samfunnet. Med «gjeldende
                        lovgivning» menes enhver norsk lov ikke bare
                        arbeidsmiljøloven.
                    </Paragraph>
                    <Paragraph>
                        Ytringer om personlige oppfatninger eller synspunkter,
                        generell misnøye, mindre disputter og uenigheter,
                        profesjonelle stridigheter e.l., betraktes ikke som
                        «varslinger» og skal ikke rapporteres i henhold til disse
                        Varslingsrutinene. Klager eller bekymringer om forhold
                        som kun gjelder den personen som varsler, er heller ikke
                        å betrakte som en varsling med mindre saken dreier seg om
                        fare for liv, helse, klima eller miljø, korrupsjon,
                        økonomisk kriminalitet, myndighetsmisbruk, uforsvarlig
                        arbeidsmiljø eller brudd på
                        personopplysnings-sikkerheten.
                    </Paragraph>

                    <Heading>Hvem behandler varslinger?</Heading>
                    <Paragraph>
                        Alle varslinger vil bli besvart, behandlet og undersøkt
                        av følgende:
                    </Paragraph>
                    <Paragraph>
                        <ul>
                            {lineOfContacts.map((lineOfContact) => (
                                <Li
                                    key={lineOfContact.id}
                                    style={{ paddingBottom: '1rem' }}
                                >
                                    {lineOfContact.first_name}{' '}
                                    {lineOfContact.last_name}
                                    {' - '}
                                    {lineOfContact.contact_information.position}
                                </Li>
                            ))}
                        </ul>
                    </Paragraph>
                    <Paragraph>
                        Ved behov, f.eks. i forbindelse med innhenting av
                        informasjon og dokumentasjon, kan Norlis HR-, Økonomi-,
                        IT-funksjon e.l. bli involvert i undersøkelsene av
                        Varslingsbehandler. Eventuelle involverte blir underlagt
                        streng taushetsplikt.
                    </Paragraph>

                    <Heading>Hvordan behandles varslinger?</Heading>
                    <Paragraph>
                        Senest 7 dager etter at et varsel er mottatt av
                        Varslingsbehandler vil varsleren få bekreftelse på
                        mottakelsen. Senest 1 måned etter bekreftelsen vil den
                        eller de det er varslet om («omvarslet»), få informasjon
                        om saken og bli innkalt til et møte med
                        Varslingsbehandler («kontradiksjonsmøte»). Selve
                        varselet vil ikke bli delt med omvarslet, men
                        vedkommende vil få informasjon om hovedinnholdet.
                        Omvarslet vil heller ikke få vite hvem varsleren er med
                        mindre varsleren har gitt sitt samtykke til dette. Dette
                        gjelder selv om varsleren ikke har valgt å varsle
                        anonymt.
                    </Paragraph>
                    <Paragraph>
                        Behandlingen av en varsling starter med at
                        Varslingsbehandler gjennomfører en forundersøkelse. Hvis
                        varslingen viser seg ikke å kunne defineres som et
                        «varsel» etter loven eller det åpenbart ikke er
                        rapportert i god tro, vil innsenderen bli informert om at
                        saken er avvist, hva som er årsaken til avvisningen og,
                        hvis aktuelt, hvor vedkommende kan henvende seg om saken
                        sin. Hvis derimot forundersøkelsen viser at varslingen er
                        velbegrunnet, vil Varslingsbehandler starte en
                        internundersøkelse. Senest i løpet av 3 måneder vil
                        Varslingsbehandler gi varsleren tilbakemelding om
                        fremdriften i internundersøkelsen og hvis mulig informere
                        om når undersøkelsen antas å være avsluttet.
                    </Paragraph>
                    <Paragraph>
                        Etter å ha gjennomført alle nødvendige undersøkelser,
                        utferdiger Varslingsbehandler en Resultatrapport som
                        sendes til øverste leder for den avdelingen omvarslet
                        tilhører. Øverste leder vil, basert på
                        Varslingsbehandlerens Resultatrapport og i samråd med
                        omvarsleds linjeleder (hvis vedkommende selv ikke er
                        berørt av saken) og HR, konkludere saken og beslutte om
                        det skal iverksettes tiltak og i tilfellet hvilke(t).
                    </Paragraph>
                    <Paragraph>
                        Omvarslet vil bli underrettet om konklusjonen og evt.
                        tiltak av nærmeste overordnede og/eller HR. Varsler vil
                        bli informert av Varslingsbehandler. Det vil ikke gis
                        informasjon som bryter med personvernforordningen/GDPR.
                        Varslingssaken vil så bli lukket. All dokumentasjon i
                        saken vil bli slettet så snart som mulig, senest 2 år
                        etter at saken er avsluttet, ref. GDPR.
                    </Paragraph>
                </PolicyContainer>
            </Container>
        </>
    )
}

export default NorliPolicy
